// Dezenter Kosten-Hinweis an KI-Auslösern („· 10 Credits"). Preis kommt aus
// /config/public (Single Source: app/services/credits.py) — nichts anzeigen,
// solange die Config nicht geladen ist (keine geratenen Zahlen).

import { useTranslation } from "react-i18next";

import { usePublicConfig } from "@/lib/publicConfig";

export default function CreditCost({
  feature,
  className,
}: {
  feature: string;
  className?: string;
}) {
  const { t } = useTranslation();
  const cfg = usePublicConfig();
  const cost = cfg?.credit_costs?.[feature];
  if (!cost) return null;
  return (
    <span className={className ?? "text-ca-surface-muted"}>
      {t(cost === 1 ? "credits.costOne" : "credits.costMany", { count: cost })}
    </span>
  );
}
